import React from "react";
import Head from "next/head";
import { CustomHead } from "@shared/ui/CustomHead";
import { SchemaJsonLd } from "@shared/ui/SchemaJsonLd";
import { CatalogSEOProps } from "./CatalogSEO.types";

export const CatalogSEO: React.FC<CatalogSEOProps> = ({
    titleTagContent,
    description,
    keywords,
    canonicalWithPage,
    metaRobots,
    ssrOgImage,
    seoSsrOgImage,
    linkRelPrev,
    linkRelNext,
    breadcrumbSchema,
    productsCarSchema
}) => (
    <>
        <CustomHead
            title={titleTagContent}
            description={description}
            keywords={keywords}
            canonical={canonicalWithPage}
            robots={metaRobots}
            openGraph={{
                title: titleTagContent,
                description: description,
                type: "website",
                image: {
                    url: ssrOgImage || seoSsrOgImage || "",
                    alt: titleTagContent
                }
            }}
        />
        <Head>
            {linkRelPrev && <link rel="prev" href={linkRelPrev} />}
            {linkRelNext && <link rel="next" href={linkRelNext} />}
        </Head>
        <SchemaJsonLd
            schemas={[breadcrumbSchema, ...(productsCarSchema ? [productsCarSchema] : [])]}
        />
    </>
);